'use strict';

import ngResource from 'angular-resource';

class ControllerConfigService {
    constructor($resource) {
        'ngInject';

        this.api = $resource(
            '/api/controller_config/:id',
            { id: '@id' },
            {
                index : { method: 'GET',  isArray: true  },
                show  : { method: 'GET',  isArray: false },
                update: { method: 'PUT',  isArray: false }
            }
        );

        this.oem_api = $resource(
            '/api/oem/controller_config/:id',
            { id: '@id' },
            {
                index : { method: 'GET',  isArray: true  },
                show  : { method: 'GET',  isArray: false },
                create: { method: 'POST', isArray: false },
                update: { method: 'PUT',  isArray: false }
            }
        );
    }
}

export default angular.module('leptonApp.ControllerConfigService', ['ngResource'])
    .service('ControllerConfigService', ['$resource', ControllerConfigService])
    .name;



// WEBPACK FOOTER //
// ./public/dev/components/api/controller_config/controller_config.service.js